"use client";

import { ReactNode, useContext, useState, useEffect } from "react";
import Accordion from "@mui/material/Accordion";
import { FilterParamsContext } from "../FilterParamsProvider";
import { FilterParams } from "@/interfaces/filterParams";

export default function ClientAccordion({
  openProperties,
  children,
  defaultExpanded = false,
}: {
  openProperties: Array<keyof FilterParams>;
  children: NonNullable<ReactNode>;
  defaultExpanded?: boolean;
}) {
  const { filterParams } = useContext(FilterParamsContext);
  const [open, setOpen] = useState(defaultExpanded);
  useEffect(() => {
    const shouldOpen = openProperties.some(
      (openProperty) =>
        filterParams[openProperty] &&
        filterParams[openProperty].length > 0 &&
        filterParams[openProperty].every((value) => value !== -1),
    );
    if (shouldOpen) {
      // this is so that the accordion doesn't close if it's already open
      setOpen((prevValue) => prevValue || shouldOpen);
    }
  }, [openProperties, filterParams]);
  return (
    <Accordion expanded={open} onChange={(_, expanded) => setOpen(expanded)}>
      {children}
    </Accordion>
  );
}
